import axios from "@/libs/axios";
import { ref } from "@vue/composition-api";

export default function useTeams() {
    const channels = ref([]);
    const users = ref([]);

    const fetchChannels = (params) => {
        return axios
            .get("channels", {
                params,
            })
            .then((response) => {
                channels.value = response.data;
                return response.data;
            });
    };
    const fetchUsers = (params) => {
        return axios
            .get("users", {
                params,
            })
            .then((response) => {
                users.value = response.data;
            });
    };

    return {
        channels,
        users,

        fetchChannels,
        fetchUsers,
    };
}
